import SortableElement from './SortableElement';
import PlaceHolder from './PlaceHolder';
import CardPlaceHolder from './CardPlaceHolder';
import BaseFormElements from './form-elements';
import TwoColumnRow from './multi-column/TwoColumnRow';
import ThreeColumnRow from './multi-column/ThreeColumnRow';
import MultiColumnRow from './multi-column/MultiColumnRow';
import CustomElement from './form-elements/CustomElement';

const {
	Header,
	Paragraph,
	Label,
	LineBreak,
	TextInput,
	Checkboxes,
	DatePicker,
	Image,
	Signature,
	HyperLink
} = BaseFormElements;

const FormElements = {};

FormElements.Header = SortableElement(Header);
FormElements.Paragraph = SortableElement(Paragraph);
FormElements.Label = SortableElement(Label);
FormElements.LineBreak = SortableElement(LineBreak);
FormElements.TextInput = SortableElement(TextInput);
FormElements.Signature = SortableElement(Signature);
FormElements.Checkboxes = SortableElement(Checkboxes);
FormElements.DatePicker = SortableElement(DatePicker);
FormElements.Image = SortableElement(Image);
FormElements.HyperLink = SortableElement(HyperLink);
FormElements.CardPlaceHolder = SortableElement(CardPlaceHolder);
FormElements.PlaceHolder = SortableElement(PlaceHolder);
FormElements.TwoColumnRow = SortableElement(TwoColumnRow);
FormElements.ThreeColumnRow = SortableElement(ThreeColumnRow);
FormElements.MultiColumnRow = SortableElement(MultiColumnRow);
FormElements.CustomElement = SortableElement(CustomElement);

export default FormElements;
